import {
  getValueFromConfigState,
  ScannerConfigurationKeys,
  ScannerConfigurations,
  scannerConfigurationsDefaultValues,
  SCANNER_RULE_ENGINE_FEATURE_NAME,
  selectConfigurationsState,
  selectConfigurationValueFrom,
} from '@epicuro-next/platform/configuration';
import { createSelector } from '@ngrx/store';

export const selectCanScannerOpenConfigStrip = createSelector(
  selectConfigurationsState,
  (configState) =>
    getValueFromConfigState<ScannerConfigurationKeys, ScannerConfigurations>(
      configState,
      SCANNER_RULE_ENGINE_FEATURE_NAME,
      ScannerConfigurationKeys.OpenConfigStripFromScannerEnabled,
      true,
    ),
);

export const selectScanToListEnabled = selectConfigurationValueFrom<
  ScannerConfigurationKeys.ScanToListEnabled,
  ScannerConfigurations
>(
  SCANNER_RULE_ENGINE_FEATURE_NAME,
  ScannerConfigurationKeys.ScanToListEnabled,
  scannerConfigurationsDefaultValues[
    ScannerConfigurationKeys.ScanToListEnabled
  ],
);

export const selectScanToBasketEnabled = selectConfigurationValueFrom<
  ScannerConfigurationKeys.ScanToBasketEnabled,
  ScannerConfigurations
>(
  SCANNER_RULE_ENGINE_FEATURE_NAME,
  ScannerConfigurationKeys.ScanToBasketEnabled,
  scannerConfigurationsDefaultValues[
    ScannerConfigurationKeys.ScanToBasketEnabled
  ],
);
